<template>
<v-list>
  <v-list-item v-for="i in 6">
    <v-card
      class="mx-auto mb-4"
    >
      <v-card-text>
        <v-img
          src="https://myrta.com/plateapi/images/COLOUR/T1?content=XJQ*959&contentType=STANDARD&size=LARGE"
        ></v-img>
      </v-card-text>
      <v-img
        src="https://res.cloudinary.com/twodm/image/fetch/c_crop,g_west,x_50/e_pixelate_region:15,g_ocr_text/v1569909644/https://www.turnbullhill.com.au/wp-content/uploads/2017/05/iStock_000017321141_Large-680x498.jpg"
      ></v-img>

      <v-card-text>
        Here is the offence description.
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
        >
          Read
        </v-btn>
        <div class="flex-grow-1"></div>
        <v-btn icon>
          <v-icon>mdi-thumb-down</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-list-item>
</v-list>
</template>

<script>
import HelloWorld from '../components/HelloWorld';

export default {
  components: {
    HelloWorld,
  },
};
</script>
